export class Savingscustomdefaultcase {

    Id                                           :number; 
    SavingsId                                    :number; 
    InstallmentNo                                :number; 
    EmployeeId                                   :number; 
    EmployeeBranchId                             :number; 
    CompanyId                                    :number; 
    SaasId                                       :number;  
    IsActive                                     :boolean; 
    Flag                                         :number;
    Remarks                                      :string;
}
